/**
 * Frontend workspace actions that interact with the API
 * The API routes automatically handle user authentication
 */

import { Workspace } from './constants';

export interface CreateWorkspaceParams {
  name: string;
  description?: string;
  billing_email: string;
}

export interface CreateWorkspaceResult {
  workspace: Workspace;
}

/**
 * Create a new workspace
 * The API endpoint will automatically get the user ID from authentication
 */
export async function createWorkspace(params: CreateWorkspaceParams): Promise<CreateWorkspaceResult> {
  const response = await fetch('/api/workspaces/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to create workspace');
  }

  const result = await response.json();
  return result;
}

/**
 * Example usage:
 * 
 * ```typescript
 * import { createWorkspace } from '@/lib/workspace/actions';
 * 
 * try {
 *   const result = await createWorkspace({
 *     name: 'My New Workspace',
 *     description: 'A workspace for my team',
 *     billing_email: 'admin@company.com'
 *   });
 *   
 *   console.log('Created workspace:', result.workspace);
 * } catch (error) {
 *   console.error('Failed to create workspace:', error.message);
 * }
 * ```
 */ 